// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IClaimCategoryBreakdownDto } from './IClaimCategoryBreakdownDto';
import {
    IClaimCategoryBreakdownDtoFromJSON,
    IClaimCategoryBreakdownDtoFromJSONTyped,
    IClaimCategoryBreakdownDtoToJSON,
    IClaimCategoryBreakdownDtoToJSONTyped,
} from './IClaimCategoryBreakdownDto';
import type { IClaimPaymentMethodBreakdownDto } from './IClaimPaymentMethodBreakdownDto';
import {
    IClaimPaymentMethodBreakdownDtoFromJSON,
    IClaimPaymentMethodBreakdownDtoFromJSONTyped,
    IClaimPaymentMethodBreakdownDtoToJSON,
    IClaimPaymentMethodBreakdownDtoToJSONTyped,
} from './IClaimPaymentMethodBreakdownDto';

/**
 * 
 * @export
 * @interface IClaimDetailsResponseDto
 */
export interface IClaimDetailsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimDetailsResponseDto
     */
    total_paid_claims_count?: number;
    /**
     * 
     * @type {Array<IClaimCategoryBreakdownDto>}
     * @memberof IClaimDetailsResponseDto
     */
    category_breakdown?: Array<IClaimCategoryBreakdownDto>;
    /**
     * 
     * @type {Array<IClaimPaymentMethodBreakdownDto>}
     * @memberof IClaimDetailsResponseDto
     */
    payment_method_breakdown?: Array<IClaimPaymentMethodBreakdownDto>;
}

/**
 * Check if a given object implements the IClaimDetailsResponseDto interface.
 */
export function instanceOfIClaimDetailsResponseDto(value: object): value is IClaimDetailsResponseDto {
    return true;
}

export function IClaimDetailsResponseDtoFromJSON(json: any): IClaimDetailsResponseDto {
    return IClaimDetailsResponseDtoFromJSONTyped(json, false);
}

export function IClaimDetailsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimDetailsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_paid_claims_count': json['total_paid_claims_count'] == null ? undefined : json['total_paid_claims_count'],
        'category_breakdown': json['category_breakdown'] == null ? undefined : ((json['category_breakdown'] as Array<any>).map(IClaimCategoryBreakdownDtoFromJSON)),
        'payment_method_breakdown': json['payment_method_breakdown'] == null ? undefined : ((json['payment_method_breakdown'] as Array<any>).map(IClaimPaymentMethodBreakdownDtoFromJSON)),
    };
}

export function IClaimDetailsResponseDtoToJSON(json: any): IClaimDetailsResponseDto {
    return IClaimDetailsResponseDtoToJSONTyped(json, false);
}

export function IClaimDetailsResponseDtoToJSONTyped(value?: IClaimDetailsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total_paid_claims_count': value['total_paid_claims_count'],
        'category_breakdown': value['category_breakdown'] == null ? undefined : ((value['category_breakdown'] as Array<any>).map(IClaimCategoryBreakdownDtoToJSON)),
        'payment_method_breakdown': value['payment_method_breakdown'] == null ? undefined : ((value['payment_method_breakdown'] as Array<any>).map(IClaimPaymentMethodBreakdownDtoToJSON)),
    };
}

